export const REGEX_NOT_DIGIT = /\D+/g;
